module.exports = __webpack_public_path__ + "media/assets/img/flags/kh-IN-5c54e2abaf0303cf2dc0ab902b52d28c.png";